// extracted by mini-css-extract-plugin
export default {"title":"Shorts_title__epxiv","shortsContainer":"Shorts_shortsContainer__XrYhD","shortItem":"Shorts_shortItem__rgkV5","iframe":"Shorts_iframe__YqF6x"};